import { EVENT_TYPE_PRIORITY, TraceTick } from './session-trace-strip.type';

/**
 * Buckets events into a list of ticks for the session trace strip.
 * @param {Array<{ id: string; event_type: string | null }>} events - The events to bucket.
 * @param {number} maxTicks - The maximum number of ticks to return.
 * @returns {Array<TraceTick>} The buckets of events.
 */
const bucketEvents = (events: { id: string; event_type: string | null }[], maxTicks: number): TraceTick[] => {
  if (events.length <= maxTicks) {
    return events.map((event) => ({
      id: event.id,
      key: (event.event_type ?? '').toUpperCase(),
      count: 1,
    }));
  }

  const bucketSize = maxTicks === 0 ? 0 : events.length / maxTicks;
  const buckets: TraceTick[] = [];
  for (let i = 0; i < maxTicks; i++) {
    const start = Math.floor(i * bucketSize);
    const end = Math.min(events.length, Math.floor((i + 1) * bucketSize));
    if (end <= start) continue;
    let bestKey = '';
    let bestPriority = -1;
    let firstId = events[start].id;
    for (let j = start; j < end; j++) {
      const key = (events[j].event_type ?? '').toUpperCase();
      const priority = EVENT_TYPE_PRIORITY[key] ?? 0;
      if (priority > bestPriority) {
        bestPriority = priority;
        bestKey = key;
        firstId = events[j].id;
      }
    }
    buckets.push({ id: firstId, key: bestKey, count: end - start });
  }
  return buckets;
};

export { bucketEvents };
